// extracted by mini-css-extract-plugin
module.exports = {"alert-custom":"AlertCustom_alert-custom__3Psh9","alert-danger":"AlertCustom_alert-danger__z4te2","alert-success":"AlertCustom_alert-success__2Ns4I"};